import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../store/slices/editModalSlice";
import {
  openModalDelete,
  closeModalDelete,
} from "../../store/slices/deleteModalQuestionsCategorySlice";
import InfoModal from "../Modals/InfoModal";
import EditModalQuestionsCategory from "../Modals/EditModal/EditModalQuestionsCategory";
import DeleteModalQuestionsCategory from "../Modals/DeleteModal/DeleteModalQuestionsCategory";

const TableItemsQuestionsCategoryResponsive = ({
  dataQuestionCategory,
  baseUrl,
}) => {
  const dispatch = useDispatch();
  const editModalState = useSelector(
    (state) => state.editModalQuestionsCategory
  );

  const handleCloseModal = (modalType) => {
    if (modalType === "edit") {
      dispatch(closeModal());
    } else if (modalType === "delete") {
      dispatch(closeModalDelete());
    } else if (modalType === "info") {
      dispatch(closeModalDelete());
    }
  };

  const handleOpenModal = (id) => {
    dispatch(openModal(id));
  };

  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  function getYesNoTextFromBoolean(value) {
    return value ? "Po" : "Jo";
  }
  return (
    <>
      <div className="block sm:hidden space-y-4">
        {dataQuestionCategory?.data?.map((item) => (
          <div
            key={item.id}
            className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
          >
            <p>
              <strong>Emri i Pyetjes:</strong> {item.name}
            </p>
            <p>
              <strong>Kategoria:</strong> {item.categoryName}
            </p>
            <p>
              <strong>Ikona:</strong>
              <br />
              <a
                href={`${baseUrl}/${item.icon}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${baseUrl}/${item.icon}`}
                  alt="Question"
                  className="w-12 h-12 object-cover mt-1"
                />
              </a>
            </p>
            <p>
              <strong>Premium:</strong>{" "}
              {getYesNoTextFromBoolean(item.isPremium)}
            </p>

            <div className="flex flex-wrap items-center gap-3 pt-2">
              <button className="text-blue-500">
                <InfoModal
                  title="Info rreth testit"
                  name="Emri i testit"
                  categoryInInfo="Kategoria e testit"
                />
              </button>
              <button
                className="text-success"
                onClick={() => handleEditItem(item.id)}
              >
                <EditModalQuestionsCategory
                  id={item.id}
                  title="Edito një pyetje me kategori"
                  submitButtonText="Edito pyetjen me kategori "
                  questionsName="Emri i pyetjes"
                  CategoryName="Lloji i kategorisë"
                  isOpen={editModalState[item.id] === true}
                />
              </button>
              <button
                className="text-danger"
                onClick={() => handleDeleteItem(item.id)}
              >
                <DeleteModalQuestionsCategory id={item.id} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TableItemsQuestionsCategoryResponsive;
